const _InterfaceItem = {
  id: 0,
  description: '',
  timestamp: '',
  unread: true,
  url: '',
  title: '',
  child_id: 0,
  action_object: {
    model: '',
    id: 0,
  },
  module: {
    id: 0,
    name: '0',
    order: 0,
  },
  type: {
    name: '',
    id: '',
  },
  actions: false,
};

function generateRouteByType(item = _InterfaceItem, type = '', isParent = false) {
  const routes = {
    task: function(_item = _InterfaceItem) {
      const taskId = _item.action_object.id;
      return {
        name: 'task-detail',
        params: { taskId },
      };
    },
    plan: function(_item = _InterfaceItem) {
      const moduleOrder = _item.module.module_order;
      return {
        name: moduleOrder ? 'planDetail' : 'plans',
        params: { moduleOrder },
      };
    },
    checklist: function(_item = _InterfaceItem) {
      const checkListId = _item.type.id;
      return {
        name: checkListId ? 'checkListId' : 'checkList',
        params: { checkListId },
      };
    },
    coins: function(_item = _InterfaceItem) {
      const model = _item.coins.model;
      const id = _item.coins.id_related;
      const data = model === 'task' && this.task({ action_object: { id } });
      return data;
    },
    rewards: { name: 'rewards' },
    ranking: { name: 'ranking' },
    childbadge: { name: 'badges' },
  };
  return routes[type] ? routes[type](item) : null;
}

export { generateRouteByType };
